// custom-input.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-yes-no",
    templateUrl: "./yes-no.component.html",
    styleUrls: ["./yes-no.component.scss"],
    standalone: false
})
export class YesNoComponent implements OnInit {
  @Input() sendTo : Object
  @Output() valueChange = new EventEmitter<Object>();

  @Input() error : boolean

  value: boolean = null;


  ngOnInit() {}

  toggle(on): void {
    this.value = on;
    this.valueChange.emit({value:this.value,sendTo: this.sendTo});
  }
}
